<template>
    <div id="popupLogin">
        <div class="loginBox">
            <div class="titles">快速注册/登录</div>
            <div class="formLogin">
                <input type="text" maxlength="11" placeholder="输入手机号" v-model="phoneNum" class="phoneNums">
                <div class="captcha">
                    <input type="text" maxlength="6" placeholder="请输入验证码" v-model="captchas">
                    <div class="send" @click="sendCode">{{codes}}</div>
                </div>
            </div>
            <div class="btnLogin" @click="logins">登录</div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['codes'],
        components:{

        },
        data() {
            return {
                phoneNum:null, // 手机号码
                captchas:null, // 验证码
            }
        },
        methods: {
            // 点击 登录
            logins:function(){
                let models = {phoneNum:this.phoneNum,captchas:this.captchas}
                this.$emit('loginOrReg',models);
            },


            // 发送验证码
            sendCode:function(){
                this.$emit('sendCodes',this.phoneNum);
            }
        },
    }
</script>

<style lang="less" scoped>
    #popupLogin{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.5);
        .loginBox{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width:285px;
            background:rgba(255,255,255,1);
            border-radius:10px;
            padding: 20px;
            .titles{
                font-size:16px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:22px;
                font-weight: 600;
                text-align: center;
                margin: 20px 0 0;
            }
            .formLogin{
                .phoneNums{
                    width: 100%;
                    height:32px;
                    font-size:14px;
                    font-weight:400;
                    line-height:14px;
                    border: none;
                    margin-top: 20px;
                    &:focus{
                        outline:none;
                    }
                }
                .captcha{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 10px;
                    input{
                        height:32px;
                        font-size:14px;
                        font-weight:400;
                        line-height:14px;
                        border: none;
                        &:focus{
                            outline:none;
                        }
                    }
                    .send{
                        width:94px;
                        height:32px;
                        border-radius:16px;
                        border:1px solid rgba(229,1,19,1);
                        font-size:14px;
                        font-weight:500;
                        color:rgba(229,1,19,1);
                        line-height:32px;
                        text-align: center;
                    }
                }
            }
            .btnLogin{
                margin: 24px 17px 4px;
                width:250px;
                height:44px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:22px;
                font-size:16px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:44px;
                text-align: center;
            }
        }
    }
</style>